import React from "react";
import { CircularProgress, Box, Typography } from "@mui/material";

const CustomLoader = ({ text }) => {
  return (
    <Box
      width="100%"
      position="fixed"
      top="50%"
      textAlign="center"
      transform="translate(-50%, -50%)"
      sx={{
        zIndex: 1000000,
      }}
    >
      <CircularProgress alignItems="center" justifyContent="center" />
      {text ? <Typography variant="body1">{text}</Typography> : null}
    </Box>
  );
};

export default CustomLoader;
